import { useEffect } from 'react';

export default function About() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const cards = document.querySelectorAll('.about-card, .about-stat');
    cards.forEach((card) => observer.observe(card));

    return () => {
      cards.forEach((card) => observer.unobserve(card));
    };
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">About White Mountain</h1>
          <p className="about-hero-subtitle">
            Empowering professionals and organizations through knowledge, leadership, and skill transformation.
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="about-stats">
        <div className="about-stats-grid">
          <div className="about-stat">
            <div className="stat-number">100+</div>
            <div className="stat-label">Active Clients</div>
          </div>
          <div className="about-stat">
            <div className="stat-number">200+</div>
            <div className="stat-label">Events Organized</div>
          </div>
          <div className="about-stat">
            <div className="stat-number">20+</div>
            <div className="stat-label">Team Members</div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-main">
        <div className="about-content-wrapper">
          {/* Vision Card */}
          <div className="about-card about-card-vision">
            <div className="about-card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </div>
            <h2>Our Vision</h2>
            <p>
              To be the trusted partner for lifelong learning and leadership across industries and regions. 
              We envision a world where every professional has access to transformative education that 
              drives real-world impact.
            </p>
          </div>

          {/* Mission Card */}
          <div className="about-card about-card-mission">
            <div className="about-card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
                <line x1="12" y1="22.08" x2="12" y2="12"/>
              </svg>
            </div>
            <h2>Our Mission</h2>
            <p>
              Equip professionals, founders, and teams with the skills, systems, and confidence needed 
              to create sustainable impact. We bridge the gap between knowledge and execution, turning 
              potential into measurable outcomes.
            </p>
          </div>

          {/* Goals Section */}
          <div className="about-goals">
            <h2 className="about-goals-title">Our Goals</h2>
            <div className="goals-grid">
              <div className="goal-item">
                <div className="goal-number">01</div>
                <h3>Deliver High-Impact Learning</h3>
                <p>Create transformative learning experiences that drive real-world results and measurable progress.</p>
              </div>
              <div className="goal-item">
                <div className="goal-number">02</div>
                <h3>Bridge Education & Execution</h3>
                <p>Connect theoretical knowledge with practical application, ensuring skills translate to success.</p>
              </div>
              <div className="goal-item">
                <div className="goal-number">03</div>
                <h3>Accelerate Outcomes</h3>
                <p>Help professionals and businesses achieve their goals faster through strategic guidance and support.</p>
              </div>
            </div>
          </div>

          {/* Values Section */}
          <div className="about-values">
            <h2 className="about-values-title">Our Core Values</h2>
            <div className="values-list">
              <div className="value-item">
                <span className="value-dot"></span>
                <div>
                  <h4>Excellence</h4>
                  <p>We strive for the highest standards in everything we do.</p>
                </div>
              </div>
              <div className="value-item">
                <span className="value-dot"></span>
                <div>
                  <h4>Integrity</h4>
                  <p>We build trust through transparency and honest communication.</p>
                </div>
              </div>
              <div className="value-item">
                <span className="value-dot"></span>
                <div>
                  <h4>Innovation</h4>
                  <p>We embrace new ideas and modern approaches to learning.</p>
                </div>
              </div>
              <div className="value-item">
                <span className="value-dot"></span>
                <div>
                  <h4>Empowerment</h4>
                  <p>We believe in unlocking the potential within every individual.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
